export enum EHelpers {
  Zero = 0,
  One = 1,
  MinusOne = -1,
  Two = 2,
  Five = 5,
  Ten = 10,
  Seven = 7,
  Six = 6,
  Hundred = 100,
}
